module.exports = __webpack_public_path__ + "assets/1b76f433cc592801e9fedd5ef6fbc329.mp3";